import { AfterViewInit, Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { ParameterHandlerService } from 'projects/common/src/app/services';
import { LanguageService } from 'projects/common/src/app/services/parameters';
import { IShift } from '../../../interfaces';
import { IFilter } from '../../../interfaces/filter-config';
import { FilterHandlerService } from '../../../services/filter/filter-handler.service';
import { GoogleAnalyticsService } from '../../../services/google/google-analytics.service';

@Component({
  selector: 'filter-shift',
  templateUrl: './filter-shift.component.html',
  styleUrls: ['./filter-shift.component.scss'],
})
export class FilterShiftComponent implements OnInit, AfterViewInit {
  @Input() public filter: IFilter;

  public shifts: IShift[];

  public selectedOption: any;

  @Output() public shiftChanged: EventEmitter<IShift>;

  constructor(
    private paramaterHandlerService: ParameterHandlerService,
    private langService: LanguageService,
    private filterHandlerService: FilterHandlerService,
    private googleAnalyticsService: GoogleAnalyticsService,
  ) {
    this.shifts = [];
    this.shiftChanged = new EventEmitter<IShift>();
  }

  /**
   * Init app
   */
  public ngOnInit(): void {
    this.filterHandlerService.getShiftByCompany().then((shifts: IShift[]) => {
      this.shifts = [{ name: this.langService.message('all-shifts'), shiftId: -1 }, ...shifts];
    });
  }

  /**
   * Component after view init
   */
  public ngAfterViewInit(): void {
    this.filterHandlerService.clearFilter$.subscribe(() => {
      this.selectedOption = null;
    });
  }

  /**
   * Function to change selected shift
   */
  public changeSelectedShift($event: IShift): void {
    this.selectedOption = $event;
    this.shiftChanged.emit($event);
    const filter = {
      filter_selected: 'filter_shift',
      value_selected: $event,
    };
    this.googleAnalyticsService.sendFilterEvent(filter);
  }
}
